import React, { useEffect, useState } from 'react';
import { dashAPI } from './SellerApi';

export const SellerDashboard = ({ seller }) => {
  const [stats, setStats] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([dashAPI.getStats(), dashAPI.getRecentOrders()])
      .then(([s, o]) => { 
        setStats(s.data); 
        setOrders(o.data || []); 
      })
      .catch(() => {
        // Fallback default mock for layout preview
        setStats({ total_sales: 45280, active_orders: 12, total_products: 24, pending_payout: 8400, sales_delta: 12, orders_delta: -3 });
        setOrders([
          { id: 'ATR-9921', product_name: 'Premium Cotton Shirt', customer_name: 'Raji K.', status: 'pending', total: 740, created_at: '2026-05-14' },
          { id: 'ATR-9920', product_name: 'Wireless Bluetooth Earbuds', customer_name: 'Siva M.', status: 'shipped', total: 1600, created_at: '2026-05-13' }
        ]);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="sp-dashboard-view">
      <div className="sp-welcome-bar">
        <h1>Welcome Back, {seller?.firstName || 'Partner'} 👋</h1>
        <p>Here is what's happening at your retail store today.</p>
      </div>

      {loading ? (
        <div className="sp-skeleton-grid">
          {[1, 2, 3, 4].map(n => <div key={n} className="sp-skeleton" style={{ height: 110 }} />)}
        </div>
      ) : (
        <div className="sp-stats-grid">
          <div className="sp-stat-card">
            <div className="sp-stat-label">TOTAL SALES</div>
            <div className="sp-stat-val">₹{stats?.total_sales?.toLocaleString('en-IN')}</div>
            <span className={`sp-stat-delta ${stats?.sales_delta >= 0 ? 'up' : 'down'}`}>
              {stats?.sales_delta >= 0 ? '▲' : '▼'} {Math.abs(stats?.sales_delta || 0)}% this week
            </span>
          </div>
          <div className="sp-stat-card">
            <div className="sp-stat-label">ACTIVE ORDERS</div>
            <div className="sp-stat-val">{stats?.active_orders}</div>
            <span className="sp-stat-delta static">Awaiting fulfillment</span>
          </div>
          <div className="sp-stat-card">
            <div className="sp-stat-label">LIVE INVENTORY</div>
            <div className="sp-stat-val">{stats?.total_products} Items</div>
            <span className="sp-stat-delta static">Active on Mart platform</span>
          </div>
          <div className="sp-stat-card">
            <div className="sp-stat-label">PENDING PAYOUT</div>
            <div className="sp-stat-val">₹{stats?.pending_payout?.toLocaleString('en-IN')}</div>
            <span className="sp-stat-delta secure">🔒 Next disbursement clear</span>
          </div>
        </div>
      )}

      <div className="sp-dashboard-panes">
        <div className="sp-card pane-main">
          <div className="sp-card-title">Recent Inbound Orders</div>
          <div className="sp-table-wrap">
            <table className="sp-table">
              <thead>
                <tr><th>ID</th><th>Product</th><th>Customer</th><th>Total</th><th>Status</th></tr>
              </thead>
              <tbody>
                {orders.map(o => (
                  <tr key={o.id}>
                    <td className="td-hi">#{o.id}</td>
                    <td>{o.product_name}</td>
                    <td>{o.customer_name}</td>
                    <td className="td-em">₹{o.total}</td>
                    <td><span className={`sp-badge ${o.status}`}>{o.status}</span></td>
                  </tr>
                ))}
                {orders.length === 0 && !loading && (
                  <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--t3)', padding: '2rem' }}>No processing orders found</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="sp-card pane-side">
          <div className="sp-card-title">Quick Operational Actions</div>
          {[
            { label: 'View Operational Orders', icon: '📦', action: 'orders' },
            { label: 'Configure Special Deals', icon: '🏷️', action: 'deals' },
            { label: 'Verify Wallet Balance', icon: '💳', action: 'wallet' },
            { label: 'Update Merchant Profile', icon: '🏪', action: 'profile' },
          ].map(q => (
            <div key={q.label} className="sp-quick-action-row"
              onClick={() => document.dispatchEvent(new CustomEvent('sp-nav', { detail: q.action }))}>
              <span className="qa-icon">{q.icon}</span>
              <span className="qa-label">{q.label}</span>
              <span className="qa-arrow">→</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};